//id
import { v4 as uuidv4 } from "uuid";

//icons
import { BsGraphUp, BsTriangle } from "react-icons/bs";
import { FaBell, FaPowerOff } from "react-icons/fa";
import { AiTwotoneSetting, AiFillUnlock } from "react-icons/ai";
import { TfiPulse, TfiPrinter } from "react-icons/tfi";
import { ImCogs } from "react-icons/im";

//images
import noalarm from "../../img/icons/noalarm4.png";
import spo2img from "../../img/icons/spo2.png";

const deviceIcon = () => {
  return (
    <div
      style={{
        display: "flex",
        width: "100px",
        justifyContent: "center",
        alignItems: "center",
        margin: "auto",
        gap: ".1em",
      }}
    >
      <FaBell />
      <span style={{ fontWeight: "60", fontFamily: "arial", fontSize: "2rem" }}>
        {" "}
        /{" "}
      </span>
      <img
        src={noalarm}
        style={{ height: "28px", padding: "0", width: "auto" }}
      ></img>
    </div>
  );
};

const spoIcon = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "37px",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
          gap: ".1em",
        }}
      >
        <img
          src={spo2img}
          style={{ height: "35px", padding: "0", width: "auto" }}
        ></img>
      </div>
    </>
  );
};

export const stateData = [
  {
    currentPageIndex: 0,
    disclaimer: true,
    init: false,
    // init: true,

    blankScreen: false,

    // lock related
    isLocked: false,
    lockScreenIndex: -1,
    isLockEnterPw: false,
    isButtonPressed: false,

    // misc app settings
    telemetry: true,
    piicConnected: true,
    settingAlertAudio: false,
    settingAlertSync: false,
    waveChanges: 0,
    reboot: false,
    standBy: false,
    standbyTime: "",
    trendsType: "Tabular Trends",
    trendsSetting: "Standard",
    disableChangeNumeric: false,

    // annotate & relearn
    relearn: false,
    annotate2test: false,
    relearnSweep: false,
    masterRelearn: false,
    annotateOrRelearn: false,
    annotate: false,
    annotate1Img: false,
    annotate2Img: false,

    //ecg settings
    ecg: true,
    ecgOffWave1: false,
    ecgOffWave2: false,

    //spo2 settings
    initiateSpo2start: false,
    spoContinuous: false,
    spoStart: false,
    spoStartimg: "",
    spoTimestamp: new Date(),
    spoDefault: true,
    refreshKey: 0,

    //alarm settings
    startInitiateAlarms: false,
    initiateAlarms: false,
    alarmsOn: true,
    alarmsPause: false,
    alarmsUnpause: 0,
    acknowledgeAlarms: false,
    hrAlarmAlert: false,
    xTachyAlarmAlert: false,

    waveData: [
      {
        name: "waveI",
        buttonName: "I",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/LI.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/LI-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "waveII",
        buttonName: "II",
        size: "1",
        primary: true,
        secondary: false,
        vid: require("../../img/waveforms/LII.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/LII-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "waveIII",
        buttonName: "III",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/LIII.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/LIII-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "aVF",
        buttonName: "aVF",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/aVF.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/aVF-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "aVR",
        buttonName: "aVR",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/aVR.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/aVR-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "aVL",
        buttonName: "aVL",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/aVL.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/aVL-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "V",
        buttonName: "V",
        size: "1",
        primary: false,
        secondary: true,

        vid: require("../../img/waveforms/V.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/V-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "MCL",
        buttonName: "MCL",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/MCL.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/MCL-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "Pleth",
        buttonName: "Pleth",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/pleth.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/Pleth-wave-ls.mp4"),
        id: uuidv4(),
      },
      {
        name: "Resp",
        buttonName: "Resp",
        size: "1",
        primary: false,
        secondary: false,
        vid: require("../../img/waveforms/resp.mp4"),
        verticalVid: require("../../img/waveforms/landscape/new/Resp-ls.mp4"),
        id: uuidv4(),
      },
    ],

    selectedNumericBox: 1,
    numericValues: [
      {
        boxName: 1,
        isSelected: true,
        box: {
          hr: true,
          spo: false,
          pvc: false,
          pulse: false,
          rr: false,
          st: false,
          qtc: false,
        },
      },
      {
        boxName: 2,
        isSelected: false,
        box: {
          hr: false,
          spo: true,
          pvc: false,
          pulse: false,
          rr: false,
          st: false,
          qtc: false,
        },
      },
      {
        boxName: 3,
        isSelected: false,
        box: {
          hr: false,
          spo: false,
          pvc: true,
          pulse: false,
          rr: false,
          st: false,
          qtc: false,
          isSelected: false,
        },
      },
      {
        boxName: 4,

        isSelected: false,

        box: {
          hr: false,
          spo: false,
          pvc: false,
          pulse: true,
          rr: false,
          st: false,
          qtc: false,
          isSelected: false,
        },
      },
      {
        boxName: 5,

        isSelected: false,

        box: {
          hr: false,
          spo: false,
          pvc: false,
          pulse: false,
          rr: true,
          st: false,
          qtc: false,
          isSelected: false,
        },
      },
      {
        boxName: 6,
        isSelected: false,
        box: {
          hr: false,
          spo: false,
          pvc: false,
          pulse: false,
          rr: false,
          st: false,
          qtc: true,
          isSelected: false,
        },
      },
    ],

    skButtons: [
      {
        name: "/spo2",
        title: "Start SpO₂",
        icon: spoIcon,
        id: uuidv4(),
      },
      {
        name: "/settings/devicemode",
        title: "Device Mode",
        icon: deviceIcon,
        id: uuidv4(),
      },
      {
        name: "/standby",
        title: "Standby",
        icon: FaPowerOff,
        id: uuidv4(),
      },
      {
        name: "/settings/mainsetup",
        title: "Main Setup",
        icon: AiTwotoneSetting,
        id: uuidv4(),
      },
      {
        name: "/ecg",
        title: "ECG: On",
        icon: TfiPulse,
        id: uuidv4(),
      },
      {
        name: "/trends",
        title: "Trends",
        icon: BsGraphUp,
        id: uuidv4(),
      },
      {
        name: "/settings/alarms",
        title: "Alarms",
        icon: BsTriangle,
        id: uuidv4(),
      },
      {
        name: "/settings/print",
        title: "Print Reports",
        icon: TfiPrinter,
        id: uuidv4(),
      },
      {
        name: "/settings/opmodes",
        title: "Op Modes",
        icon: ImCogs,
        id: uuidv4(),
      },
      {
        name: "/lock",
        title: "Lock: Off",
        icon: AiFillUnlock,

        id: uuidv4(),
      },
    ],

    settingPages: [
      {
        name1: "screenontime",
        title: "Screen On Time",
        settings: [
          {
            title: `Always On`,
          },
          {
            title: "1 min",

            functionButton: true,
          },
          {
            title: "2 min",

            functionButton: true,
          },
          {
            title: "3 min",

            functionButton: true,
          },
          {
            title: "4 min",

            functionButton: true,
          },
        ],
      },
      {
        name1: "adjustsize",
        title: "Adjust Size",
        settings: [
          {
            title: `x1/2`,
            functionButton: true,
          },
          {
            title: "x1",
            functionButton: true,
          },
          {
            title: "x2",
            functionButton: true,
          },
          {
            title: "x4",
            functionButton: true,
          },
        ],
      },
      {
        name1: "respadjustsize",
        title: "Adjust Size",
        settings: [
          {
            title: `x1/2`,
            functionButton: true,
          },
          {
            title: "x1",
            functionButton: true,
          },
          {
            title: "x2",
            functionButton: true,
          },
          {
            title: "x4",
            functionButton: true,
          },
        ],
      },
      {
        name1: "resp",
        title: "Setup Resp",
        settings: [
          {
            title: "Alarms: Off",
            gray: true,
          },
          {
            title: "Alarm Limits:",
            gray: true,
          },
          {
            title: "Apnea Time: 20 sec",
            gray: true,
          },
          {
            title: "Adjust Size: x1",
            link: true,
            clickTo: "/settings/respadjustsize",
          },
          {
            title: "Resp: On",
            gray: true,
          },
          {
            title: "Change Numeric",
            link: true,
            clickTo: "/settings/changenumeric",
          },
        ],
      },
      {
        name1: "changenumeric",
        title: "Change Numeric",
        settings: [
          {
            title: "SpO₂",
            functionButton: true,
            functionName: "changenumeric",
          },
          {
            title: "Pulse",
            functionButton: true,
            functionName: "changenumeric",
          },
          {
            title: "HR",
            functionButton: true,
            functionName: "changenumeric",
          },
          {
            title: "RR",
            functionButton: true,
            functionName: "changenumeric",
          },
          {
            title: "PVC",
            functionButton: true,
            functionName: "changenumeric",
          },
          {
            title: "QTC",
            functionButton: true,
            functionName: "changenumeric",
          },
          {
            title: "ST",
            functionButton: true,
            functionName: "changenumeric",
          },
        ],
      },
      {
        name1: "mainsetup",
        title: "Main Setup",
        settings: [
          {
            title: "Setup ECG",
            link: true,
            clickTo: "/settings/ecgsetup",
            mainsetup: true,
          },
          {
            title: "Arrhythmia",
            link: true,
            clickTo: "/settings/arrhythmia",
            mainsetup: true,
          },
          {
            title: `Setup SpO₂`,
            link: true,
            clickTo: "/settings/spo2",
            mainsetup: true,
          },
          {
            title: "Alarms",
            link: true,
            clickTo: "/settings/alarms",
          },
          {
            title: "Pulse",
            link: true,
            clickTo: "/settings/pulse",
            mainsetup: true,
          },
          {
            title: "Resp",
            link: true,
            clickTo: "/settings/resp",
            mainsetup: true,
          },
          {
            title: "Screen On Time",
            link: true,
            clickTo: "/settings/screenontime",
          },
        ],
      },
      {
        name1: "alarmvolume",
        title: "Alarm Volume",
        settings: [
          {
            title: "5",
            functionButton: true,
          },
          {
            title: "4",
            functionButton: true,
          },
          {
            title: "3",
            functionButton: true,
          },
          {
            title: "2",
            functionButton: true,
          },
          {
            title: "1",
            functionButton: true,
          },
        ],
      },
      {
        name1: "leadplacement",
        title: "Lead Placement",
        settings: [
          {
            title: "Standard",
            functionButton: true,
          },
          {
            title: "EASI",
            functionButton: true,
          },
        ],
      },
      {
        name1: "devicemode",
        title: "Device Mode",
        settings: [
          {
            title: "Telemetry",
            functionButton: true,
          },
          {
            title: "Monitor",
            functionButton: true,
          },
        ],
      },
      {
        name1: "alarms",
        title: "Alarms",
        settings: [
          {
            title: "Alarm Volume: 3",
            link: true,
            clickTo: "/settings/alarmvolume",
          },
          {
            title: "Review Alarms",
            link: true,
            clickTo: "/reviewalarms",
          },
          {
            banner: true,
            // functionButton: true,
            bannerName: "Alarms On",
          },
          {
            banner: true,
            // functionButton: true,
            bannerName: "Initiate Alarms",
          },
        ],
      },
      {
        name1: "ecgsetup",
        title: "Setup ECG",
        settings: [
          {
            title: "Alarm Limits",
            link: true,
            clickTo: "/settings/hralarmlimits",
          },
          {
            title: "Primary Lead: II",
            gray: true,
          },
          {
            title: "Secondary Lead: V",
            gray: true,
          },
          {
            title: "Paced Mode: Off",
            gray: true,
          },
          {
            title: "Adjust Size: 1x ",
            link: true,
            clickTo: "/settings/adjustsize",
          },
          {
            title: "Arrhythmia ",
            link: true,
            clickTo: "/settings/arrhythmia",
          },
          {
            title: "Lead Placement: Standard ",
            link: true,
            clickTo: "/settings/leadplacement",
          },

          {
            title: "Hexad: Off",
            gray: true,
          },
          {
            title: "Va Lead",
            gray: true,
          },
          {
            title: "Vb Lead",
            gray: true,
          },
          {
            title: "Change Numeric",
            link: true,
            clickTo: "/settings/changenumeric",
          },
        ],
      },
      {
        name1: "stleads",
        title: "ST Leads",
        settings: [
          {
            title: "ST-I: 0.0",
            gray: true,
          },
          {
            title: "ST-II: 0.1",
            gray: true,
          },
          {
            title: "ST-III: 0.0",
            gray: true,
          },
          {
            title: "ST-aVF: 0.0",
            gray: true,
          },
          {
            title: "ST-aVR: 0.0",
            gray: true,
          },
          {
            title: "ST-aVL: 0.0",
            gray: true,
          },
          {
            title: "ST-V: 0.1",
            gray: true,
          },
          {
            title: "ST-V: 0.2",
            gray: true,
          },
          {
            title: "ST Views",
            link: true,
            clickTo: "/settings/stviews",
          },
          {
            title: "Arrhythmia ",
            link: true,
            clickTo: "/settings/arrhythmia",
          },
          {
            title: "Lead Placement: Standard ",
            link: true,
            clickTo: "/settings/leadplacement",
          },
          {
            title: "Paced Mode: Off",
            gray: true,
          },

          {
            title: "Hexad: Off",
            gray: true,
          },
          {
            title: "Va Lead",
            gray: true,
          },
          {
            title: "Vb Lead",
            gray: true,
          },
          {
            title: "Change Numeric",
            link: true,
            clickTo: "/settings/changenumeric",
          },
        ],
      },
      {
        name1: "stviews",
        title: "ST Views",
        settings: [
          {
            title: "All",
            functionButton: true,
          },
          {
            title: "Inferior",
            functionButton: true,
          },
          {
            title: "Lateral",
            functionButton: true,
          },
          {
            title: "Anterior-Lateral",
            functionButton: true,
          },
          {
            title: "Anterior",
            functionButton: true,
          },
          {
            title: "Septal",
            functionButton: true,
          },
          {
            title: "Right",
            functionButton: true,
          },
          {
            title: "Left",
            functionButton: true,
          },
        ],
      },
      {
        name1: "spo2",
        title: "Setup Spo₂",
        settings: [
          {
            title: "Mode: Manual",
            link: true,
            clickTo: "/settings/spo2mode",
          },
          {
            title: "Tone Modulation: Off",
            link: true,
            clickTo: "/settings/spo2tonemodulation",
          },
          {
            title: "Alarm Limits",
            link: true,
            clickTo: "/settings/spo2alarmlimits",
          },
          {
            title: "Desat Limit: 80",
            gray: true,
          },
          {
            title: "Start SpO₂",
            link: true,
            clickTo: "/",
          },
          {
            title: "Alarms: On",
            gray: true,
          },
          {
            title: "SpO₂: On",
          },
          {
            title: "Repeat Time: 15 min",
            gray: true,
          },
          {
            title: "Change Numeric",
            link: true,
            clickTo: "/settings/changenumeric",
          },
        ],
      },
      {
        name1: "pulse",
        title: "Pulse",
        settings: [
          {
            title: "Pulse: On",
            link: true,
            clickTo: "#",
          },
          {
            title: "Change Numeric",
            link: true,
            clickTo: "/settings/changenumeric",
          },
        ],
      },
      {
        name1: "changewaveTest",
        title: "Change Wave",
        settings: [
          {
            title: "Adjust Size: x1",
          },
        ],
      },
      {
        name1: "/settings/arrhythmia",
        title: "Arrhythmia",
        settings: [
          {
            title: "Relearn Arrhy",
            link: true,
            clickTo: "/",
          },
          {
            title: "Annotate Arrhy: Off",
            functionButton: true,
          },
          {
            title: "Annotate: On",
            gray: true,
          },
          {
            title: "Pause Threshold: 2.00 sec",
            gray: true,
          },
          {
            title: "VTach HR: 100",
            gray: true,
          },
          {
            title: "VTach Run: 5",
            gray: true,
          },
          {
            title: "Vent Rhythm: 14",
            gray: true,
          },
          {
            title: "SVT HR: 180",
            gray: true,
          },
          {
            title: "PVCs/min: 10",
            gray: true,
          },
          {
            title: "Non-Sustain: On",
            gray: true,
          },
          {
            title: "Vent Rhythm: On",
            gray: true,
          },
          {
            title: "Run PVCs: On",
            gray: true,
          },
          {
            title: "Pair PVCs: On",
            gray: true,
          },
          {
            title: "R-on-T PVCs: On",
            gray: true,
          },
          {
            title: "V.Bigeminy: On",
            gray: true,
          },
          {
            title: "V.Trigeminy: On",
            gray: true,
          },
          {
            title: "PVCs/min: On",
            gray: true,
          },
          {
            title: "Pacer n.Pac: On",
            gray: true,
          },
          {
            title: "Pause: On",
            gray: true,
          },
          {
            title: "Missed Beat: On",
            gray: true,
          },
          {
            title: "SVT: On",
            gray: true,
          },
          {
            title: "Afib: On",
            gray: true,
          },
          {
            title: "IrregularHR: On",
            gray: true,
          },
          {
            title: "TimeOut 1st: 3 min",
            gray: true,
          },
          {
            title: "Time Out 2nd: 10 min",
            gray: true,
          },
          {
            title: "Analysis Mode Multi Lead",
            gray: true,
          },
          {
            title: "QRS Detection: 300μV ",
            gray: true,
          },
          {
            title: "Change Numeric",
            link: true,
            clickTo: "/settings/changenumeric",
          },
        ],
      },
      {
        name1: "spo2tonemodulation",
        title: "Tone Modulation",
        settings: [
          {
            title: "Off",
            functionButton: true,
          },
          {
            title: "1",
            functionButton: true,
          },
          {
            title: "2",
            functionButton: true,
          },
          {
            title: "3",
            functionButton: true,
          },
          {
            title: "4",
            functionButton: true,
          },
        ],
      },
      {
        name1: "spo2mode",
        title: "Setup SpO₂",
        settings: [
          {
            title: "Manual",
            functionButton: true,
          },
          {
            title: "Continuous",
            functionButton: true,
          },
          {
            title: "Auto",
            functionButton: true,
          },
        ],
      },
      {
        name1: "hralarmlimits",
        title: "Alarm Limits",
        settings: [
          {
            title: "High Limit: 120",
            gray: true,
          },
          {
            title: "Low Limit: 60",
            gray: true,
          },
        ],
      },
      {
        name1: "spo2alarmlimits",
        title: "Alarm Limits",
        settings: [
          {
            title: "High Limit: 100",
            gray: true,
          },
          {
            title: "Low Limit: 90",
            gray: true,
          },
        ],
      },
      {
        name1: "print",
        title: "Print Reports",
        settings: [
          {
            title: "Central Report A",
            functionButton: true,
          },
          {
            title: "Central Report B",
            functionButton: true,
          },
          {
            title: "Central Report C",
            functionButton: true,
          },
        ],
      },
      {
        name1: "opmodes",
        title: "Op Modes",
        settings: [
          {
            title: "Monitoring",
            functionButton: true,
          },
          {
            title: "Demo",
            functionButton: true,
          },
          {
            title: "Config",
            functionButton: true,
          },
          {
            title: "Service",
            functionButton: true,
          },
        ],
      },
      {
        name1: "devicestatus",
        title: "Device Status",
        settings: [
          {
            title: "Equipment Label: TELE9",
            gray: true,
          },
          {
            title: "Link:",
            link: true,
            clickTo: "/settings/linkinfo",
            icon: require("../../img/icons/monitor2.png"),
            iconText: "CentralMonitoring",
          },
          {
            title: "Battery: 100%",
            icon: require("../../img/icons/battery.png"),
            link: true,
            clickTo: "/settings/battery",
          },
          {
            title: "Device Info",
            link: true,
            clickTo: "/settings/deviceinfo",
          },
        ],
      },
      {
        name1: "battery",
        title: "Device Status",
        settings: [
          {
            title: "AA Battery",
            gray: true,
          },
          {
            title: "Percent Remaining: 100%",
            gray: true,
          },
          {
            title: "Voltage: 5.0206000 V%",
            gray: true,
          },
          {
            title: "Av. Current: 120 mA",
            gray: true,
          },
          {
            title: "Av. Power: 607 mW",
            gray: true,
          },
        ],
      },
      {
        name1: "patient",
        title: "Patient Demogr.",
        settings: [
          {
            title: "Last Name",
            label: true,
            gray: true,
          },
          {
            title: "First Name",
            label: true,
            gray: true,
          },
          {
            title: "Middle Name",
            label: true,
            gray: true,
          },
          {
            title: "Lifetime ID",
            label: true,
            gray: true,
          },
          {
            title: "Encounter ID",
            label: true,
            gray: true,
          },
          {
            title: "Patient Cat",
            label: true,
            gray: true,
          },
          {
            title: "Paced Mode",
            label: true,
            gray: true,
          },
          {
            title: "Height",
            label: true,
            gray: true,
          },
          {
            title: "Weight",
            label: true,
            gray: true,
          },
          {
            title: "DOB",
            label: true,
            gray: true,
          },
          {
            title: "Gender",
            label: true,
            gray: true,
          },
        ],
      },
      {
        name1: "selftest",
        title: "Self Test Results",
        settings: [
          {
            title: "POST Summary: FAIL",
            gray: true,
          },
          {
            title: "DRAM: PASS",
            gray: true,
          },
          {
            title: "FLASH: PASS",
            gray: true,
          },
          {
            title: "SYS EEPROM: PASS",
            gray: true,
          },
          {
            title: "HW Watchdog: PASS",
            gray: true,
          },
          {
            title: "Configuration: PASS",
            gray: true,
          },
          {
            title: "SW License: FAIL",
            gray: true,
          },
          {
            title: "RTC: PASS",
            gray: true,
          },
          {
            title: "CTS: PASS",
            gray: true,
          },
          {
            title: "WLAN: PASS",
            gray: true,
          },
          {
            title: "BLE: PASS",
            gray: true,
          },
          {
            title: "Pressure Sensor: PASS",
            gray: true,
          },
          {
            title: "M4 Firmware: PASS",
            gray: true,
          },
          {
            title: "Display: PASS",
            gray: true,
          },
          {
            title: "Backup Battery: PASS",
            gray: true,
          },
          {
            title: "Li-Ion Battery: NA",
            gray: true,
          },
          {
            title: "AA Battery Tray: NA",
            gray: true,
          },
          {
            title: "Regulators: PASS",
            gray: true,
          },
          {
            title: "ECG: PASS",
            gray: true,
          },
          {
            title: "Respiration: PASS",
            gray: true,
          },
          {
            title: "Sp02: PASS",
            gray: true,
          },
          {
            title: "Li-Ion Batt. LT: NA",
            gray: true,
          },
          {
            title: "AA Batt. Tray: NA",
            gray: true,
          },
        ],
      },
      {
        name1: "changewave",
      },
      {
        name1: "changewave2",
      },
      {
        name1: "leadset",
        title: "Leadset Info",
        settings: [
          {
            title: "Part Num: 989803171851",
            gray: true,
          },
          {
            title: "Serial Num: 05112000000792",
            gray: true,
          },
          {
            title: "HW Rev: 0.0",
            gray: true,
          },
          {
            title: "Reg Type: AAMI",
            gray: true,
          },
          {
            title: "Wire Type: 5",
            gray: true,
          },
          {
            title: "SpO₂: 1",
            gray: true,
          },
          {
            title: "Usage: Reusable",
            gray: true,
          },
        ],
      },
      {
        name1: "deviceinfo",
        title: "Device Info",
        gray: true,
        settings: [
          {
            title: "Self Test Results",
            link: true,
            clickTo: "/settings/selftest",
          },
          {
            title: "Options: S02 C01 C03 M0",
          },
          {
            title: "Leadset Info",
            link: true,
            clickTo: "/settings/leadset",
          },
          {
            text: [
              {
                label: [
                  { label: "Appl SW: 4.0.0.0 - 1030", id: uuidv4() },
                  { label: "S/N: USPP000138", id: uuidv4() },
                ],
                text: [],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
          {
            text: [
              {
                label: [{ label: "Radio", id: uuidv4() }],
                text: [
                  { text: "FW REV: 5.10", id: uuidv4() },
                  { text: "HW REV: 2045", id: uuidv4() },
                ],
                img: false,
                aside: [],
                id: uuidv4(),
              },
              {
                label: [{ label: "BLE", id: uuidv4() }],
                text: [{ text: "FW REV: 1.1", id: uuidv4() }],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
          {
            text: [
              {
                label: [{ label: "SpO₂", id: uuidv4() }],
                text: [
                  { text: "HW Rev: 8.00.03", id: uuidv4() },
                  { text: "Boot: A.04.18", id: uuidv4() },
                  { text: "FW Rev: A.06.40", id: uuidv4() },
                ],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
          {
            text: [
              {
                label: [{ label: "Kernel", id: uuidv4() }],
                text: [
                  { text: "Linux pwm 5.4.190-mx40+ #1", id: uuidv4() },
                  { text: "PREEMPT Tue Oct 18 09:14:15 UTC", id: uuidv4() },
                ],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
          {
            text: [
              {
                label: [
                  { label: "Product Rev: A.00.00", id: uuidv4() },
                  { label: "Speaker Rev: A.00.00", id: uuidv4() },
                  { label: "TouchRev: A.00.00", id: uuidv4() },
                  { label: "Button Rev: A.00.00", id: uuidv4() },
                  { label: "Display Rev: A.00.00", id: uuidv4() },
                  { label: "SpO₂ Module Rev: A.00.00", id: uuidv4() },
                  { label: "CTS Ant1 Rev: A.00.00", id: uuidv4() },
                  { label: "Frontend Flex Rev: A.00.00", id: uuidv4() },
                  { label: "Bezel Rev: A.00.00", id: uuidv4() },
                ],
                text: [
                  { text: "Linux pwm 5.4.190-mx40+ #1", id: uuidv4() },
                  { text: "PREEMPT Tue Oct 18 09:14:15 UTC", id: uuidv4() },
                ],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
        ],
      },
      {
        name1: "linkinfo",
        title: "Link Information",
        settings: [
          {
            text: [
              {
                label: [{ label: "Link Quality", id: uuidv4() }],
                text: [{ text: "Central Monitoring", id: uuidv4() }],
                img: [
                  {
                    imgUrl: require("../../img/icons/linkinfo.png"),
                    id: uuidv4(),
                  },
                ],
                aside: [
                  { aside: "1.4ghz SH", id: uuidv4() },
                  { aside: "RSSI: -41", id: uuidv4() },
                  { aside: "Retries: 0", id: uuidv4() },
                  { aside: "LQI: 4", id: uuidv4() },
                ],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
          {
            text: [
              {
                label: [
                  { label: "RF Access Code:12", id: uuidv4() },
                  { label: "Conn. Status: Active", id: uuidv4() },
                  { label: "Modulation: GFSK", id: uuidv4() },
                  { label: "Fmld: 3.255 RA1->", id: uuidv4() },
                ],
                text: [{ text: "0.18", id: uuidv4() }],
                img: false,
                aside: [],
                id: uuidv4(),
              },
              {
                label: [
                  { label: "SQI: 4", id: uuidv4() },
                  { label: "TX Retries: 47", id: uuidv4() },
                  { label: "PDU/s: 0 (0)", id: uuidv4() },
                ],
                text: [],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
          {
            text: [
              {
                label: [
                  { label: "MAC Address: 00:09:FB:66:02:B8", id: uuidv4() },
                  { label: "IP Address: 10.228.64.110", id: uuidv4() },
                  { label: "Subnet Mask: 255.255.255.0", id: uuidv4() },
                  { label: "Default Gateway: 10.228.64.1", id: uuidv4() },
                  { label: "Server IP: 10.228.40.203", id: uuidv4() },
                  { label: "Multicast: 224.0.23.173", id: uuidv4() },
                ],
                text: [],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
          {
            text: [
              {
                label: [{ label: "Auth/Encrypt: Off", id: uuidv4() }],
                text: [],
                img: false,
                aside: [],
                id: uuidv4(),
              },
            ],
            id: uuidv4(),
          },
        ],
      },
    ],

    popuppages: [
      {
        name1: "localaudio",
        title: "Local Audio",
        iconOn: FaBell,
        iconOff: require("../../img/icons/noalarm4.png"),
        body: [],
        bodyOn: [
          "Alarms are audible at this device.",
          "Alarms are audible at the Information Center.",
        ],
        bodyOff: [
          "Alarms are NOT audible at this device.",
          "Alarms are audible at the Information Center.",
        ],
        bodyPicOff: [
          "Alarms are audible at this device.",
          "Alarms are NOT audible at the Information Center.",
        ],
        buttons: true,
        buttonText: ["Close"],
      },
      {
        name1: "ecg",
        title: "Turn ECG",
        iconOn: TfiPulse,
        body: [
          "ECG Monitoring and alarming will be turned off at:",
          "The Device and Information Center.",
        ],
        bodyOff: [],
        bodyOn: [],
        bodyPicOff: [],
        buttons: true,
        buttonText: ["Close", "Confirm"],
      },
      {
        name1: "standby",
      },
    ],

    trends: [
      {
        name1: "tabulartrends",
        title: "Tabular Trends: Standard",

        tabs: [
          {
            id: uuidv4(),
            time: "1min",
            chart: require("../../img/trends/tab-1min.png"),
            active: true,
          },
          {
            id: uuidv4(),
            time: "5min",
            chart: require("../../img/trends/tab-5min.png"),
            active: false,
          },
          {
            id: uuidv4(),
            time: "15min",
            chart: require("../../img/trends/tab-15min.png"),
            active: false,
          },
          {
            id: uuidv4(),
            time: "30min",
            chart: require("../../img/trends/tab-30min.png"),
            active: false,
          },
          {
            id: uuidv4(),
            time: "1hr",
            chart: require("../../img/trends/tab-1hr.png"),
            active: false,
          },
        ],
      },
    ],

    initValues: {
      initWaveData: [
        {
          name: "waveI",
          buttonName: "I",
          size: "1",
          primary: true,
          secondary: false,
          vid: require("../../img/waveforms/LI.mp4"),
          verticalVid: require("../../img/waveforms/landscape/LI-lss.mp4"),
          id: uuidv4(),
        },
        {
          name: "waveII",
          buttonName: "II",
          size: "1",
          primary: false,
          secondary: true,
          vid: require("../../img/waveforms/LII.mp4"),
          verticalVid: require("../../img/waveforms/landscape/LII-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "waveIII",
          buttonName: "III",
          size: "1",
          primary: false,
          secondary: false,
          vid: require("../../img/waveforms/LIII.mp4"),
          verticalVid: require("../../img/waveforms/landscape/LIII-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "aVF",
          buttonName: "aVF",
          size: "1",
          primary: false,
          secondary: false,
          vid: require("../../img/waveforms/aVF.mp4"),
          verticalVid: require("../../img/waveforms/landscape/new/aVF-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "aVR",
          buttonName: "aVR",
          size: "1",
          primary: false,
          secondary: false,
          vid: require("../../img/waveforms/aVR.mp4"),
          verticalVid: require("../../img/waveforms/landscape/aVR-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "aVL",
          buttonName: "aVL",
          size: "1",
          primary: false,
          secondary: false,
          vid: require("../../img/waveforms/aVL.mp4"),
          verticalVid: require("../../img/waveforms/landscape/aVL-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "V",
          buttonName: "V",
          size: "1",
          primary: false,
          secondary: false,

          vid: require("../../img/waveforms/V.mp4"),
          verticalVid: require("../../img/waveforms/landscape/V-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "MCL",
          buttonName: "MCL",
          size: "1",
          primary: false,
          secondary: false,
          vid: require("../../img/waveforms/MCL.mp4"),
          verticalVid: require("../../img/waveforms/landscape/MCL-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "Pleth",
          buttonName: "Pleth",
          size: "1",
          primary: false,
          secondary: false,
          vid: require("../../img/waveforms/pleth.mp4"),
          verticalVid: require("../../img/waveforms/landscape/pleth-ls.mp4"),
          id: uuidv4(),
        },
        {
          name: "Resp",
          buttonName: "Resp",
          size: "1",
          primary: false,
          secondary: false,
          vid: require("../../img/waveforms/resp.mp4"),
          verticalVid: require("../../img/waveforms/landscape/resp-ls.mp4"),
          id: uuidv4(),
        },
      ],
      initNumericValues: [
        {
          boxName: 1,
          isSelected: true,
          box: {
            hr: true,
            spo: false,
            pvc: false,
            pulse: false,
            rr: false,
            st: false,
            qtc: false,
          },
        },
        {
          boxName: 2,
          isSelected: false,
          box: {
            hr: false,
            spo: true,
            pvc: false,
            pulse: false,
            rr: false,
            st: false,
            qtc: false,
          },
        },
        {
          boxName: 3,
          isSelected: false,
          box: {
            hr: false,
            spo: false,
            pvc: true,
            pulse: false,
            rr: false,
            st: false,
            qtc: false,
            isSelected: false,
          },
        },
        {
          boxName: 4,

          isSelected: false,

          box: {
            hr: false,
            spo: false,
            pvc: false,
            pulse: true,
            rr: false,
            st: false,
            qtc: false,
            isSelected: false,
          },
        },
        {
          boxName: 5,

          isSelected: false,

          box: {
            hr: false,
            spo: false,
            pvc: false,
            pulse: false,
            rr: true,
            st: false,
            qtc: false,
            isSelected: false,
          },
        },
        {
          boxName: 6,
          isSelected: false,
          box: {
            hr: false,
            spo: false,
            pvc: false,
            pulse: false,
            rr: false,
            st: false,
            qtc: true,
            isSelected: false,
          },
        },
      ],
    },
  },
];
